import { registerDynamicForm } from "@/utils/dynamicFormRegistry";

const ALISOF_MODULE = "alisof_module";

export function registerDynamicForms() {
  registerDynamicForm({
    modelName: "Contrato",
    modes: ["add", "edit", "view"],
    requiresModule: ALISOF_MODULE,
    customFormKey: "alisof:Contrato",
    autonomous: true,
    component: () => import("./ContratoForm.vue"),
  });
  // Factura sin contrato: Contrato_factura no tiene form-schema propio (es un group), así
  // que va como formulario custom del alta/edición estándar, no autónomo.
  registerDynamicForm({
    modelName: "Contrato_factura",
    modes: ["add", "edit"],
    requiresModule: ALISOF_MODULE,
    component: () => import("./FacturaSinContratoForm.vue"),
  });
}
